import React from 'react'
import gift from "../../../assets/images/gift-voucher.png"
import { Link } from 'react-router-dom'

const EmbarkBanner = ({heading,description,dynamicImage,content,button}) => {
  return (
    <section className="keyzi_conquer--wrapper  keyzi_embark--wrapper" id="banner-gift">
      <div className="container">
        <div className="keyzi_conquer--inner">
          <div className="row">
            <div className="col-md-6">
              <div className="left-side">
              <h3>{heading || "Give the Gift of Driving"}</h3>
              {!button && content?.[0]?.title && <p>{content?.[0]?.title || "Buy a Lesson Voucher Today!"}</p>}
              {button && <a href="#contact-us" className='btn btn-primary'>{button}</a>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="right-side">
                <img src={"https://keyzi.com.au/keyzi-admin/public" + content?.[0]?.image}  alt={content?.[0]?.image_attribute} className='img-fluid'/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EmbarkBanner